import { render, staticRenderFns } from "./JobAnnouncements.vue?vue&type=template&id=5b35ea23"
import script from "./JobAnnouncements.vue?vue&type=script&lang=js"
export * from "./JobAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./JobAnnouncements.vue?vue&type=style&index=0&id=5b35ea23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports